/**
 * Trạng thái kiểm tra hóa đơn
 */
export default {
  WaitChecking: 1,// hóa đơn đang chờ kiểm tra
  Valid: 2,// hóa đơn hợp lệ
  Invalid: 16,// hóa đơn không hợp lệ
};
